module.exports = __webpack_public_path__ + "img/zoom-out.d3df2c71.svg";